import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getBrandReports = id => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/report/brand-report/' + id,
    headers: getHeaders(),
  });
};


export const getUserReports = id => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/report/user-report/' + id,
    headers: getHeaders(),
  });
};


export const sendToAdmin = (id, userReportId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/report/user-report/' +
      id +
      '/' +
      userReportId +
      '/send-to-admin',
    headers: getHeaders(),
  });
};


export const postReports = data => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/store/api/secure/v2/report/user-report',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const postReportsView = data => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/store/api/secure/v3/report/user-report',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const postSalesReports = data => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/store/api/secure/v1/report/sales-report',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const postGarmentReports = data => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/store/api/secure/v1/report/garment-report',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const postTaxReports = data => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/store/api/secure/v1/report/tax-report',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const postOrderReports = data => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/store/api/secure/v1/report/order-report',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const postCollectionReports = data => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/store/api/secure/v1/report/collection-report',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const postPendingRevenueReports = data => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/store/api/secure/v1/report/pending-revenue-report',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};





